import { createSelector } from 'reselect';

import {
  // Utils
  localizedLink,
  hasUserSelector,

  // Navigation
  iphoneIpadFooterSelector,
  androidFooterSelector,
  windows10FooterSelector,
  // Props
  localeSelector,
} from '@xingternal/platform-layout-selectors';

const appLinksSelector = createSelector(
  hasUserSelector,
  localeSelector,
  iphoneIpadFooterSelector,
  androidFooterSelector,
  windows10FooterSelector,
  (hasUser, locale, iphoneIpadFooter, androidFooter, windows10Footer) =>
    hasUser
      ? [iphoneIpadFooter, androidFooter, windows10Footer]
          .filter(Boolean)
          .map(localizedLink(locale))
      : []
);

export { appLinksSelector };
